import { render, staticRenderFns } from "./tabsLable.vue?vue&type=template&id=e081bbfc&scoped=true"
import script from "./tabsLable.vue?vue&type=script&lang=js"
export * from "./tabsLable.vue?vue&type=script&lang=js"
import style0 from "./tabsLable.vue?vue&type=style&index=0&id=e081bbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e081bbfc",
  null
  
)

export default component.exports